import { defineStore } from "pinia";
import RepositoryFactory from "@/repositories/apiGateWay/repositoryFactory";
import { API_RESPONSE_SUCCESS, BAD_REQUEST_ERROR_CODE, HTTP_CODE_SUCCESS } from "@/data/constants";
const apiGatewayRepository = RepositoryFactory.get('apiGateway');
import ApplicationError from "@/helpers/applicationError";
import router from "@/router";
import i18n from '@/i18n/main'

const { t } = i18n.global;
export const useContactUsStore = defineStore('contactUsStoreId', {
    state: () => {
        return {
            step: "agreement",
            isLoading: false,
            params: {
                last_name: "",
                first_name: "",
                phone_number: "",
                email: "",
                service_name: "",
                payment_id: "",
                category_id: "",
                content: ""
            },
            selectedCategory: {
                custom_fields: [],
            },
            customFields: [],
            selectedMerchant: "",
            categoryError: false,
            contentError: false,
            customFieldError: false,
            contactUsErrors: {},
            contactUsErrorsMsg: null,
            inquiryCategoryList: [],
            isLoggedIn: false,
        }
    },
    actions: {
        resetValues(){
            this.step = "agreement";
            this.params = {
                last_name: "",
                first_name: "",
                phone_number: "",
                email: "",
                service_name: "",
                payment_id: "",
                category_id: "",
                content: "",
                company_app_id: "",
                transaction_uuid: ""
            };
            this.selectedCategory = {
                custom_fields: [],
            };
            this.selectedMerchant = "";
            this.customFieldError = false;
        },
        resetForm(){
            this.params = {
                last_name: "",
                first_name: "",
                phone_number: "",
                email: "",
                service_name: "",
                payment_id: "",
                category_id: "",
                content: "",
                company_app_id: "",
                transaction_uuid: ""
            };
            this.selectedCategory = {
                custom_fields: [],
            };
            this.selectedMerchant = "";
            this.customFieldError = false;
        },
        resetFormForLoggedInUser(){
            this.params.payment_id = "";
            this.params.category_id = "";
            this.params.content = "";
            this.selectedCategory = {
                custom_fields: [],
            };
            this.selectedMerchant = "";
            this.customFieldError = false;
        },
        async getInquiryCategories(){
            try {
                const inquiryCategoryList = await apiGatewayRepository.getInquiryCategories({"id": ""});

                if (inquiryCategoryList.success == API_RESPONSE_SUCCESS && inquiryCategoryList.code == HTTP_CODE_SUCCESS) {
                    this.inquiryCategoryList = inquiryCategoryList.data;
                }
            } catch (error) {
                this.isLoading = false;
                throw new ApplicationError(e.message, {}, e)
            }
        },
        async createContactUs(){
            try {
                
                this.params.custom_fields = this.customFields;
                const response = await apiGatewayRepository.createContactUs(this.params);
                if(response.success != API_RESPONSE_SUCCESS){
                    throw new ApplicationError("Create contact us error", {})
                }
            } catch (error) {
                this.isLoading = false;
                if(error.response.data && error.response.data.errors){
                    const data = error.response.data;

                    if (data.code === BAD_REQUEST_ERROR_CODE && typeof data.errors === "object") {
                        this.contactUsErrors = data.errors;
                    }

                    if (data.code === BAD_REQUEST_ERROR_CODE && typeof data.errors === "string") {
                        this.contactUsErrorsMsg = data.errors;
                    }

                    return false;
                }
                throw new ApplicationError(error.message, {}, error);
            }
        }
    }
});